<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <b-container v-else><br>

      <!-- POPUP: Choose Report Type -->
      <b-modal id="coverage-select-modal" v-model="showCoverageModal" title="Select Report Type" hide-footer>
        <div>
          <b-form-group label="Choose report to download:">
            <b-form-radio v-model="selectedCoverageType" value="consolidated">
              Consolidated Course Coverage
            </b-form-radio>

            <b-form-radio v-model="selectedCoverageType" value="mycourse">
              My Course Coverage
            </b-form-radio>
          </b-form-group>

          <div class="text-right mt-3">
            <b-button variant="secondary" @click="showCoverageModal = false">Cancel</b-button>
            <b-button variant="danger" v-if="!downloadInProgress" class="ml-2" @click="proceedCoverageSelection">
              Download
            </b-button>
            <span v-else class="text-success">Download In Progress....</span>
          </div>
        </div>
      </b-modal>


     <b-row class="align-items-center justify-content-between mb-3">

        <!-- Left side: Filters -->
        <b-col cols="auto" class="d-flex align-items-center">

          <!-- Topic Coverage Filter -->
          <div class="mr-3">
            <b-form-select
              style="width:250px"
              v-model="topicCoveragefilter"
              :options="topicCoveragefilterOptions">
            </b-form-select>
          </div>

          <!-- Programs Filter -->
          <div v-if="usergroupOptions && usergroupOptions.length > 1">
            <label class="font-weight-bold mb-1">
              {{ getCustomNames.userGroup.custom_name }} :
            </label>

            <b-form-select
              style="width:250px"
              v-model="usergroup"
              :options="usergroupOptions"
              value-field="id"
              text-field="name">
            </b-form-select>
          </div>


        </b-col>

        <!-- Right side: Download button -->
        <b-col cols="auto">
          <b-button @click="openCoveragePopup" variant="danger" size="sm">
            Download PDF
          </b-button>
        </b-col>

      </b-row>


      <!-- Info message row -->
      <b-row>
        <b-col>
          <span v-if="topicCoveragefilterName == 'Topic covered v/s Topic pending'" class="text-danger">
            A topic mapped to at least one session attend session will be considered as topic covered.
          </span>
        </b-col>
      </b-row>


      <div v-for="(usergroup, ugIndex) in usergroups" :key="ugIndex" class="mb-5">
        <div style="font-size: 16px !important; font-weight: 600" class="text-center">
          {{ usergroup.name }}
        </div>

        <table class="table table-bordered table-striped">
          <tbody v-for="(subgroup, sgIndex) in usergroupSubgroups(usergroup.id)" :key="sgIndex">

            <!-- ROW 1 -->
            <tr class="table-header" style="background-color: lightgray; font-weight: 700;">
              <!-- Semester (merge down 2 rows) -->
              <th rowspan="2" class="text-center">
                {{ subgroup.name }}
              </th>

              <!-- Modules main title -->
              <th rowspan="2" :colspan="maximumModulesInSubgroup(subgroup.id)" class="text-center">
                Modules - Regular<br>
                ({{ topicCoveragefilterName }})
              </th>

              <!-- Class Count main title -->
              <th colspan="5" class="text-center">
                Class Count
              </th>
            </tr>

            <!-- ROW 2 -->
            <tr class="table-header" style="background-color: gray;">

              <!-- Class count labels -->
              <th class="text-center">Regular</th>
              <th class="text-center">Extra</th>
              <th class="text-center">Revision</th>
              <th class="text-center">Remedial</th>
              <th class="text-center">Bridge</th>
            </tr>


            <!-- DATA ROWS -->
            <tr v-for="(course, cIndex) in subgroupCourses(subgroup.id)" :key="cIndex">

              <!-- course name column -->
              <td>{{ course.name }}</td>

              <!-- MODULE CELLS -->
              <td v-for="i in maximumModulesInSubgroup(subgroup.id)" :key="`m-${cIndex}-${i}`">
                <!-- module values -->
                <div v-if="Object.values(course.module_coverage)[i - 1]">
                  <span class="text-secondary">
                    {{ Object.keys(course.module_coverage)[i - 1] }}
                  </span>
                  <br>
                  {{ Object.values(course.module_coverage)[i - 1].attendance_count }} /
                  {{ Object.values(course.module_coverage)[i - 1].planned_attendance_count }}

                  <span v-if="Object.values(course.module_coverage)[i - 1].planned_attendance_count != 0" :class="{
                    'text-danger':
                      Object.values(course.module_coverage)[i - 1].attendance_count /
                      Object.values(course.module_coverage)[i - 1].planned_attendance_count <
                      0.9,
                    'text-success':
                      Object.values(course.module_coverage)[i - 1].attendance_count /
                      Object.values(course.module_coverage)[i - 1].planned_attendance_count >=
                      1
                  }">
                    <span class="text-primary"> | </span>
                    {{
                      Math.round(
                        (Object.values(course.module_coverage)[i - 1].attendance_count /
                          Object.values(course.module_coverage)[i - 1].planned_attendance_count) *
                        100
                      )
                    }}%
                  </span>
                </div>
              </td>

              <!-- COUNT COLUMNS -->
              <td>{{ coursesRegularAttCounts[course.id] }}</td>
              <td>{{ coursesExtraAttCounts[course.id] }}</td>
              <td>{{ coursesRevisionAttCounts[course.id] }}</td>
              <td>{{ coursesRemedialAttCounts[course.id] }}</td>
              <td>{{ coursesBridgeAttCounts[course.id] }}</td>
            </tr>

          </tbody>
        </table>
        <br>
      </div>


      <!--my course coverage report-->
      <!-- ===== MY COURSE COVERAGE (MATCHED FORMAT) ===== -->

      <p v-if="myCourseCoverages.length > 0" class="text-center mt-4">
        <strong>My Course Coverage</strong>
      </p>

      <table class="table table-bordered table-striped" v-if="myCourseCoverages.length > 0">

        <!-- HEADER ROW 1 -->
        <tr class="table-header" style="background-color: lightgray; font-weight:700;">

          <!-- Course name -->
          <th rowspan="2" class="text-center">Course</th>

          <!-- Modules Main Title -->
          <th :colspan="maxModulesMyCoverage" rowspan="2" class="text-center">
            Modules - Regular <br>
            ({{ topicCoveragefilterName }})
          </th>


          <!-- Class Count Summary -->
          <th colspan="5" class="text-center">
            Class Count
          </th>


        </tr>

        <!-- HEADER ROW 2 -->
        <tr class="table-header" style="background-color: gray; font-weight:600;">
          <th class="text-center">Regular</th>
          <th class="text-center">Extra</th>
          <th class="text-center">Revision</th>
          <th class="text-center">Remedial</th>
          <th class="text-center">Bridge</th>
        </tr>


        <!-- DATA ROWS -->
        <tr v-for="(course, cIndex) in myCourseCoverages" :key="'myc-' + cIndex">

          <!-- Course name -->
          <td>{{ course.name }} - {{ course.usersubgroup.code }}</td>



          <!-- MODULE CELLS (ALIGNED WITH FIRST TABLE FORMAT) -->
          <td v-for="(moduleData, mIndex) in normalizeModules(course.module_coverage)" :key="'mod-' + mIndex">
            <div v-if="moduleData">
              <span class="text-secondary">{{ moduleData.key }}</span><br>

              {{ moduleData.attendance_count }}/{{ moduleData.planned_attendance_count }}

              <span v-if="moduleData.planned_attendance_count !== 0" :class="{
                'text-danger': moduleData.attendance_count /
                  moduleData.planned_attendance_count < 0.9,
                'text-success': moduleData.attendance_count /
                  moduleData.planned_attendance_count >= 1
              }">
                <span class="text-primary"> | </span>
                {{ Math.round(
                  (moduleData.attendance_count /
                    moduleData.planned_attendance_count) * 100
                ) }}%
              </span>
            </div>
          </td>

          <!-- CLASS COUNTS -->
          <td>{{ coursesRegularAttCounts[course.id] }}</td>
          <td>{{ coursesExtraAttCounts[course.id] }}</td>
          <td>{{ coursesRevisionAttCounts[course.id] }}</td>
          <td>{{ coursesRemedialAttCounts[course.id] }}</td>
          <td>{{ coursesBridgeAttCounts[course.id] }}</td>

        </tr>

      </table>

    </b-container>

  </div>
</template>

<script>
export default {
  props: [],
  components: {
  },
  async created() {
    this.fetchData = true;
    await this.getUsergroups();
    await this.getCourseCoverage();
    this.fetchData = false;
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
    maxModulesMyCoverage() {
      if (!this.myCourseCoverages.length) return 0;
      return Math.max(
        ...this.myCourseCoverages.map(c =>
          Object.keys(c.module_coverage).length
        )
      );
    }
  },

  data() {
    return {
      fetchData: false,
      usergroupOptions: [],
      usergroup: null,
      selectedCoverageType: 'consolidated',
      showCoverageModal: false,
      downloadInProgress: false,
      topicCoveragefilter: 1,
      topicCoveragefilterName: 'Actual session v/s Planned session',
      topicCoveragefilterOptions: [
        { value: 1, text: "Actual session v/s Planned session" },
        { value: 2, text: "Topic covered v/s Topic pending" },
      ],
      coursesWithModule: [],
      myCourseCoverages: [],
      usergroups: [],
      subgroups: [],
      coursesExtraAttCounts: {},
      coursesBridgeAttCounts: {},
      coursesRevisionAttCounts: {},
      coursesRegularAttCounts: {},
      coursesRemedialAttCounts: {},
    };
  },
  watch: {
    "topicCoveragefilter": function () {
      if (this.topicCoveragefilter == 1) {
        this.topicCoveragefilterName = 'Planned session v/s Actual session';
      }
      else {
        this.topicCoveragefilterName = 'Topic covered v/s Topic pending';
      }
      this.getCourseCoverage();
    },
    "usergroup": function () {
      this.getCourseCoverage();
    },
    
  },
  methods: {
    openCoveragePopup() {
      const hasConsolidated = this.usergroups.length > 0;
      const hasMyCoverage = this.myCourseCoverages.length > 0;

      if (hasConsolidated && hasMyCoverage) {
        this.showCoverageModal = true; // show popup
      } else {
        // only one table: directly download
        this.courseCoverageMonitoringPdfDownload();
      }
    },
    async proceedCoverageSelection() {
      this.downloadInProgress = true;
      if (this.selectedCoverageType === "consolidated") {
        await this.downloadConsolidatedCoverage();
      } else {
        await this.downloadMyCourseCoverage();
      }
      this.downloadInProgress = false;
      this.showCoverageModal = false;
    },
    async downloadConsolidatedCoverage() {
      await this.courseCoverageMonitoringPdfDownload('consolidated');
    },

    async downloadMyCourseCoverage() {
      await this.courseCoverageMonitoringPdfDownload('my');
    },

    // Normalize module columns for uniform table structure
    normalizeModules(modules) {
      let arr = [];
      let keys = Object.keys(modules);

      for (let key of keys) {
        arr.push({
          key,
          attendance_count: modules[key].attendance_count,
          planned_attendance_count: modules[key].planned_attendance_count
        });
      }

      // Fill empty cells to match max column count
      while (arr.length < this.maxModulesMyCoverage) {
        arr.push(null);
      }

      return arr;
    },
    maximumModulesInSubgroup(subgroupId) {
      let courses = this.subgroupCourses(subgroupId);
      let moduleCount = 0;
      courses.forEach(course => {
        moduleCount = Object.keys(course.module_coverage).length < moduleCount ? moduleCount : Object.keys(course.module_coverage).length;
      });
      return moduleCount;
    },
    subgroupCourses(subgroupId) {
      return this.coursesWithModule.filter(
        (course) => {
          return course.usersubgroup_id == subgroupId;
        }
      );
    },
    usergroupSubgroups(usergroupId) {
      return this.subgroups.filter(
        (subgroup) => {
          return subgroup.usergroup_id == usergroupId;
        }
      );
    },
    subgroupModuleKeysLength(subgroupId) {
      // console.log(subgroupId, this.subgroupModuleKeys[subgroupId], this.subgroupModuleKeys[subgroupId].length);
      return this.subgroupModuleKeys[subgroupId].length;
    },
    
    async getUsergroups() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/coursecoverage/monitoring/usergroups`;

      await this.$axios
        .get(url)
        .then((response) => {
          this.usergroupOptions = response.data || [];

          //  auto-select first usergroup id
          if (this.usergroupOptions.length > 0) {
            this.usergroup = this.usergroupOptions[0].id;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },


    async getCourseCoverage() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/coursecoverage/monitoring?topic_coverage_filter=${this.topicCoveragefilter}&usergroup=${this.usergroup}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.coursesWithModule = response.data.coursesWithModule;
          this.usergroups = response.data.usergroups;
          this.subgroups = response.data.subgroups;
          this.coursesRemedialAttCounts = response.data.coursesRemedialAttCounts;
          this.coursesExtraAttCounts = response.data.coursesExtraAttCounts;
          this.coursesBridgeAttCounts = response.data.coursesBridgeAttCounts;
          this.coursesRevisionAttCounts = response.data.coursesRevisionAttCounts;
          this.coursesRegularAttCounts = response.data.coursesRegularAttCounts;
          this.myCourseCoverages = response.data.myCourseCoverages;
        })
        .catch((error) => {
          error;
        });
    },
    async courseCoverageMonitoringPdfDownload(type = null) {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/coursecoverage/monitoring/report/pdfexport?topic_coverage_filter=${this.topicCoveragefilter}`;
      await this.$axios
        .post(
          url,
          {report_type: type},
          { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "courseCoverageMonitoringPDF.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          let errorText = "Failed to Download, please try again";
          this.$toast.error(errorText, {
            position: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>

<style scoped>
.table-header {
  background-color: gray !important;
}
</style>
